import { Page, PageFace } from 'ui/components/Page'
import { Panel, PanelFace } from 'ui/components/Panel'

import { ReportBreadcrumbs } from '../../components'
import { Filter } from './components/Filter'
import { PageActions } from './components/PageActions'
import { Table } from './components/Table'
import { EmailHistoryReportContextProvider } from './context/EmailHistoryReportContextProvider'

const EmailHistoryReport = () => (
  <EmailHistoryReportContextProvider>
    <Page face={PageFace.PRIMARY} title={<ReportBreadcrumbs title="Email History Report" />} actions={<PageActions />}>
      <Panel rounded shadowed collapsible={false} face={PanelFace.SECONDARY}>
        <Filter />
        <Table />
      </Panel>
    </Page>
  </EmailHistoryReportContextProvider>
)

export default EmailHistoryReport
